
import { mapState } from 'vuex'
import QuantitySelector from '@/components/QuantitySelector'
import OptionalNuxtLink from '@/components/OptionalNuxtLink.vue'
import InfoIcon from '@/static/svg/prescription/info-icon.svg'
import CloseIcon from '@/static/svg/nav/close-icon.svg'
import LineItemPrescription from '@/components/LineItemPrescription'

export default {
  components: {
    QuantitySelector,
    InfoIcon,
    CloseIcon,
    OptionalNuxtLink,
    LineItemPrescription,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    maxQuantity: {
      type: Number,
      default: 36,
    },
    linkEnabled: {
      type: Boolean,
      default: true,
    },
    canShowPackSizeSwitcher: {
      type: Boolean,
      default: false,
    },
    canShowEditPrescription: {
      type: Boolean,
      default: false,
    },
    // Is this line item currently in edit prescription state?
    editingOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['cdn']),
    productLink() {
      return this.$getLink(`/product/${this.item.productId}`)
    },
    showPackSizeSwitcher() {
      return this.canShowPackSizeSwitcher && !!this.upgradePathItems.length
    },
    upgradePathItems() {
      return this.item.upgradePath?.products.filter((upgradeItem) => upgradeItem.id !== this.item.productId) || []
    },
    showEditLink() {
      return this.canShowEditPrescription && !this.editingOptions && !!this.item.options?.length
    },
    originalUnitPriceIsSet() {
      return this.priceIsSet(this.item.originalUnitPrice)
    },
    unitPriceIsSet() {
      return this.priceIsSet(this.item.unitPrice)
    },
  },
  methods: {
    getTotal(item) {
      const { originalUnitPrice, unitPrice, qty } = item
      return unitPrice ? unitPrice * qty : originalUnitPrice * qty
    },
    confirmToRemove(item) {
      this.$emit('confirm-remove', item)
    },
    updatedQuantity(item, quantity) {
      if (quantity > 0) {
        this.$emit('quantity-updated', { item, quantity })
      } else {
        this.confirmToRemove(item)
      }
    },
    upgradeItem(upgradePathItem) {
      this.$emit('item-upgraded', { item: this.item, upgradePathItem })
    },
    editItemOptions() {
      this.$emit('edit-item-options', this.item)
    },
    cancelEditItemOptions() {
      this.$emit('cancel-edit-item-options')
    },
    async itemOptionsUpdated(updatedOptions) {
      const { productId, image, name, originalUnitPrice, unitPrice, packSize, options } = this.item
      if (JSON.stringify(options) === JSON.stringify(updatedOptions)) {
        this.cancelEditItemOptions()
        return
      }
      const toItem = {
        productId,
        image,
        name,
        originalUnitPrice,
        unitPrice,
        packSize,
        options: updatedOptions,
      }

      await this.$store.dispatch('basket/replaceLineItem', { fromItem: this.item, toItem })
      this.$emit('item-options-updated')
    },
    priceIsSet(price) {
      return price !== undefined && price !== null
    },
  },
}
